// extracted by mini-css-extract-plugin
module.exports = {"youtube":"YoutubePlayer_youtube__6jw73","video-wrapper":"YoutubePlayer_video-wrapper__gi0hE","video":"YoutubePlayer_video__ekr_B"};